import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.61612 3.61612C4.10427 3.12796 4.89573 3.12796 5.38388 3.61612L18.25 16.4822L18.25 8.25C18.25 7.55964 18.8096 7 19.5 7C20.1904 7 20.75 7.55964 20.75 8.25V19.5C20.75 20.1904 20.1904 20.75 19.5 20.75H8.25C7.55964 20.75 7 20.1904 7 19.5C7 18.8096 7.55964 18.25 8.25 18.25H16.4822L3.61612 5.38388C3.12796 4.89573 3.12796 4.10427 3.61612 3.61612Z"
        fill={colorValue}
      />
    </svg>
  );
};
